
export const GET_BLOGS = "GET_BLOGS"
export const GET_BLOGS_FAIL = "GET_BLOGS_FAIL"
export const GET_BLOGS_SUCCESS = "GET_BLOGS_SUCCESS"



export const GET_BLOGS_BY_SLUG = "GET_BLOGS_BY_SLUG"
export const GET_BLOGS_BY_SLUG_FAIL = "GET_BLOGS_BY_SLUG_FAIL"
export const GET_BLOGS_BY_SLUG_SUCCESS = "GET_BLOGS_BY_SLUG_SUCCESS"

